import React, { Component } from "react";

import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import BrandLogo from "../components/BrandLogo";
import InvitationMessage from "../components/invitation/InvitationMessage";
import InvitationBody from "../components/invitation/personalmessage";

interface Props {
  invitation: server.dto.Invitation
}

export default class InvitationDetails extends Component<Props> {
  public render(): JSX.Element {
    const { brand, shows, message, invitationBody } = this.props.invitation;

    return (
      <>
        <BrandLogo brand={brand} />

        <InvitationMessage
          message={message}
          brandName={brand.name}
        />

        {(invitationBody) && <InvitationBody
          message={invitationBody}
        />}

        <div>
          <div className="margin-bottom-small">
            <h3>
              {RESX.InvoiceDocument.Concerning}:
            </h3>
          </div>

          <div className="flex-column gap-small">
            {shows.map((item, idx) => (
              <div key={idx} className="padding-larger gray-100">
                <LinkedShowLines
                  dateTime={item.dateTime}
                  eventDescription={item.eventDescription}
                  format="big" />
              </div>
            ))
            }
          </div>
        </div>
      </>
    );
  }
}
